import type { StandardResource } from "../types";
import { sortStandardResources } from "./standardResources";

/** Dedupe, drop unknown ids, order follows standard resources master. */
export function normalizeLinkedResourceIds(
  resources: StandardResource[],
  requested: string[] | undefined | null,
): string[] {
  if (!requested?.length) return [];
  const sorted = sortStandardResources(resources);
  const valid = new Set(sorted.map((r) => r.id));
  const kept = [...new Set(requested.filter((id) => valid.has(id)))];
  const orderIndex = new Map(sorted.map((r, i) => [r.id, i]));
  kept.sort((a, b) => (orderIndex.get(a) ?? 999) - (orderIndex.get(b) ?? 999));
  return kept;
}
